module.exports = __webpack_public_path__ + "3acab9cf2f247ca5307291bd9d9d2684.jpg";